import { useEffect } from 'react';
import { Box, Spinner, Text, VStack } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { setAuthenticated } from '../redux/features/authSlice';

const mainServiceUrl = import.meta.env.VITE_MAIN_SERVICE_URL || '';

export default function AuthCallbackPage() {
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(window.location.search);
  const error = searchParams.get('error');

  useEffect(() => {
    const verify = async () => {
      if (!error) {
        try {
          const res = await fetch(`${mainServiceUrl}/auth/verify`, { credentials: 'include' });
          if (res.ok) {
            const data = await res.json();
            if (data?.authenticated) {
              dispatch(setAuthenticated({ user: data.user || {} }));
            }
          }
        } catch {}
      }
      setTimeout(() => {
        window.location.href = error ? `/login?error=${encodeURIComponent(error)}` : '/';
      }, 1000);
    };
    verify();
  }, [error, dispatch]);

  return (
    <VStack minH="100vh" justify="center" spacing={4}>
      <Spinner size="xl" color="brand.500" />
      <Text color="gray.600">{error ? 'Authentication failed. Redirecting...' : 'Signing you in...'}</Text>
      {error && <Text fontSize="sm" color="red.500" maxW="400px" textAlign="center">{error}</Text>}
    </VStack>
  );
}
